export default __webpack_public_path__ + "media/images/lp/conversion-icon-pc-7108855f826f736b750a0d93537fdd6f.png";